
import Vue from 'vue';
import Router from 'vue-router';
import Cookie from '@/common/util/cookie';

Vue.use(Router);

import App from '@/App';
// import UnFound from '@/views/Unfound';

// 用户中心-首页
const UserCenter = r => require.ensure([], () => r(require('@/views/UserCenter')), 'UserCenter');;
const UserHome = r => require.ensure([], () => r(require('@/views/user/userHome/userHome')), 'UserHome');
// 用户中心-手机号登录
const UserPhoneLogin = r => require.ensure([], () => r(require('@/views/user/userPhoneLogin/userPhoneLogin')), 'UserPhoneLogin');
// 用户中心作业答案
const Answer = r => require.ensure([], () => r(require('@/views/user/answer/answer')), 'Answer');
// 用户中心-学而思账号登录
const UserXesLogin = r => require.ensure([], () => r(require('@/views/user/userxesLogin/userxesLogin')), 'UserXesLogin');
// 绑定手机号
const UserBindPhone = r => require.ensure([], () => r(require('@/views/user/userBindPhone/userBindPhone')), 'UserBindPhone');
// 用户中心-完善信息
const CompleteInfo = r => require.ensure([], () => r(require('@/views/user/completeInfo/completeInfo')), 'CompleteInfo');
// 用户中心-表单
const UserInfo = r => require.ensure([], () => r(require('@/views/user/userInfo/userInfo')), 'UserInfo');
//用户中心-表单详细信息
const UserSex = r => require.ensure([], () => r(require('@/views/user/userSex/userSex')), 'UserSex');
const UserSwitchPhone = r => require.ensure([], () => r(require('@/views/user/userSwitchPhone/userSwitchPhone')), 'UserSwitchPhone');
const UserMail = r => require.ensure([], () => r(require('@/views/user/userMail/userMail')), 'UserMail');
//切换学员编号
const SwitchStuNum = r => require.ensure([],() => r(require('@/views/user/switchStuNum/switchStuNum')),'SwitchStuNum');
//资料下载
const UserDocument = r => require.ensure([], () => r(require('@/views/user/userDocument/userDocument')), 'UserDocument');
const UserDownload = r => require.ensure([], () => r(require('@/views/user/userDownload/userDownload')), 'UserDownload');
const DownloadSelect = r => require.ensure([], () => r(require('@/views/user/downloadSelect/downloadSelect')), 'DownloadSelect');
const DocQrCode = r => require.ensure([],() => r(require('@/views/user/docQrCode/docQrCode')),'DocQrCode');
//考试
const ExamCard = r => require.ensure([], () => r(require('@/views/user/examCard/examCard')), 'ExamCard');
const ExamInfo = r => require.ensure([], () => r(require('@/views/user/examInfo/examInfo')), 'ExamInfo');
const ExamNotice = r => require.ensure([], () => r(require('@/views/user/examNotice/examNotice')), 'ExamNotice');
const ExamQuery = r => require.ensure([], () => r(require('@/views/user/examQuery/examQuery')), 'ExamQuery');
const ScheduleQuery = r => require.ensure([], () => r(require('@/views/user/scheduleQuery/scheduleQuery')), 'ScheduleQuery');
const ClassList = r => require.ensure([], () => r(require('@/views/user/classList/classList')), 'ClassList');
const TestList = r => require.ensure([], () => r(require('@/views/user/testList/testList')), 'TestList');
const IfsReport = r => require.ensure([], () => r(require('@/views/user/ifsReport/ifsReport')), 'IfsReport');
const Follow = r => require.ensure([], () => r(require('@/views/user/follow/follow')), 'Follow');
// 本地图文
const Imagetext = r => require.ensure([], () => r(require('@/views/Imagetext')), 'Imagetext');
const Wximagetext = r => require.ensure([], () => r(require('@/views/imagetext/wximagetext/wximagetext')), 'Wximagetext');
const Pcimagetext = r => require.ensure([], () => r(require('@/views/imagetext/pcimagetext/pcimagetext')), 'Pcimagetext');

// 微信授权失败公共页面
const Authfail = r => require.ensure([], () => r(require('@/views/authfail.vue')), 'Authfail');

export default new Router({
    mode: 'history', // 删除url中的#
    routes: [
        {
            path: '/',
            component: App,
        },
        // 微信授权失败公共页面
        {
          path: '/authfail',
          component: Authfail,
          meta: {
              title: ''
          },
          beforeEnter(to, from, next) {
              document.title = to.meta.title;
              next();
          }
      },
        //PC端二维码
        {
            path: '/docqrcode',
            component: DocQrCode,
            meta: {
                title: '文件二维码'
            },
            beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
        },
        // 用户中心-首页
        {
            path: '/user',
            component: UserCenter,
            children: [
                // 中心
                {
                    path: 'home',
                    component: UserHome,
                    meta: {
                        title: '我的中心'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 手机号登录
                {
                    path: 'phonelogin',
                    component: UserPhoneLogin,
                    meta:{
                        title: '手机号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 作业答案
                {
                    path: 'answer',
                    component: Answer,
                    meta:{
                        title: '补充材料'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 完善信息
                {
                    path: 'compinfo',
                    component: CompleteInfo,
                    meta:{
                        title: '完善信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 学而思账号登录
                {
                    path: 'xeslogin',
                    component: UserXesLogin,
                    meta: {
                        title: '学而思账号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 表单
                {
                    path: 'info',
                    component: UserInfo,
                    meta: {
                        title: '个人信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //性别
                {
                    path:'sex',
                    component: UserSex,
                    meta: {
                        title: '选择性别'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 切换手机
                {
                    path:'switchphone',
                    component: UserSwitchPhone,
                    meta: {
                        title: '切换手机号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 绑定手机
                {
                    path:'bindphone',
                    component: UserBindPhone,
                    meta: {
                        title: '绑定手机号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //邮箱
                {
                    path:'mail',
                    component: UserMail,
                    meta: {
                        title: '填写邮箱'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //切换学员编号
                {
                    path:'stunum',
                    component: SwitchStuNum,
                    meta:{
                        title:'切换学员编号'
                    },
                    beforeEnter(to,from,next){
                        document.title=to.meta.title;
                        next();
                    },
                },
                //我的资料下载
                {
                    path: 'document',
                    component: UserDocument,
                    meta: {
                        title: '我的资料'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //素材管理
                {
                    path: 'material',
                    component: UserDownload,
                    meta: {
                        title: '资料下载'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //下载选择
                {
                    path: 'select',
                    component: DownloadSelect,
                    meta: {
                        title: '文件详情'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examcard',
                    component: ExamCard,
                    meta: {
                        title: '准考证'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examinfo',
                    component: ExamInfo,
                    meta: {
                        title: '考场信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                    beforeLeave (to, from, next) {
                        console.log(to)
                        console.log(form)
                        next();
                    }
                },
                {
                    path: 'examNotice',
                    component: ExamNotice,
                    meta: {
                        title: '考场信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examquery',
                    component: ExamQuery,
                    meta: {
                        title: '考场列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        if (from.fullPath.indexOf('classLIst') > -1) {
                            window.location.href = '/user/examquery'
                        } else {
                            next();
                        }

                    },
                },
                {
                    path: 'scheduleQuery',
                    component: ScheduleQuery,
                    meta: {
                        title: '课表查询'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'classList',
                    component: ClassList,
                    meta: {
                        title: '课次列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        console.log(from)
                        if (from.fullPath.indexOf('gotoWhere=1') > -1) {
                            // this.$router.go('/user/examquery')
                            window.location.href = '/user/examquery'
                        } else {
                            next();
                        }
                        next();
                    },
                },
                {
                    path: 'testlist',
                    component: TestList,
                    meta: {
                        title: '考试列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'ifsreport',
                    component: IfsReport,
                    meta: {
                        title: 'IFS成绩报告'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'follow',
                    component: Follow,
                    meta: {
                        title: '关注公众号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
            ]
        },
        {
            path: '/:userCenterId',
            component: UserHome,
        },
        // 本地图文
        {
            path: '/pictext',
            component: Imagetext,
            children: [
                {
                    path: 'wximgtext',
                    component: Wximagetext
                },
                {
                    path: 'pcimgtext',
                    component: Pcimagetext
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js